import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'
import TimeBlockCalendar from '../../../ClientReservations/Amenities/TimeBlockCalendar/TimeBlockCalendar'
import { buildTimeBlockSummaryText } from '../../helpers'

const SelectDateAndTime = ({
  onBack = () => {},
  onNext = () => {},
  onCalendarChange = () => {},
  setHasConflicts = () => {},
  setReservedTimeRanges = () => {},
  style,
  title,
  hasConflicts,
  canGoNext,
  buildingData,
  formState,
}) => {
  const { t } = useTranslation(['reservations', 'common'])
  const [timeSelectViewVisible, setTimeSelectViewVisible] = useState(false)
  const [selectedTimeRange, setSelectedTimeRange] = useState(null)

  const showSummary =
    (formState.date && formState.endDate) ||
    (selectedTimeRange && typeof selectedTimeRange.startTime === 'number')

  const onBackClick = () => {
    setHasConflicts(false)
    if (timeSelectViewVisible) {
      setTimeSelectViewVisible(false)
      setSelectedTimeRange(null)
    } else {
      onBack()
    }
  }

  return (
    <div>
      <div className="reservations-modal-content reservations-add-time-block-modal" style={style}>
        <span className="title">
          {timeSelectViewVisible
            ? t('reservations:reservationForClientForm.stepperSteps.selectTime')
            : title}
        </span>
        <TimeBlockCalendar
          amenity={formState.amenity}
          building={buildingData}
          locationId={formState.location ? formState.location.id : null}
          timeSelectViewVisible={timeSelectViewVisible}
          selectedTimeRange={selectedTimeRange}
          onChange={onCalendarChange}
          setIsTimeSelectVisible={setTimeSelectViewVisible}
          setSelectedTimeRange={setSelectedTimeRange}
          setHasConflicts={setHasConflicts}
          setReservedTimeRanges={setReservedTimeRanges}
        />
        {hasConflicts ? (
          <div className="reservation-calendar-summary warning">
            <b>
              <Icon icon="exclamationPointTriangle" />{' '}
              {t('reservations:selectDateAndTime.conflictingReservationsDetected')}
            </b>
            <p>{t('reservations:selectDateAndTime.conflictingReservationsDescription')}</p>
          </div>
        ) : (
          showSummary && (
            <div className="reservation-calendar-summary">
              <b>{t('reservations:reservationCalendarSummary.summary')}</b>
              <p>
                {buildTimeBlockSummaryText(
                  {
                    amenity: formState.amenity,
                    date: formState.date,
                    endDate: formState.endDate,
                    startTime: selectedTimeRange && selectedTimeRange.startTime,
                    endTime: selectedTimeRange && selectedTimeRange.endTime,
                    blockFullDay: formState.blockFullDay,
                    blockMultipleDays: formState.blockMultipleDays,
                  },
                  t,
                )}
              </p>
            </div>
          )
        )}
      </div>
      <div className="reservations-modal-actions">
        <button className="button button-gray" onClick={onBackClick}>
          {t('common:actions.back')}
        </button>
        {hasConflicts ? (
          <button className="button button-primary caution" disabled={!canGoNext} onClick={onNext}>
            {t('reservations:selectDateAndTime.reviewConflictingReservations')}
          </button>
        ) : (
          <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
            {t('reservations:shared.next')}
          </button>
        )}
      </div>
    </div>
  )
}

SelectDateAndTime.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onCalendarChange: PropTypes.func,
  setHasConflicts: PropTypes.func,
  setReservedTimeRanges: PropTypes.func,
  title: PropTypes.string,
  canGoNext: PropTypes.bool,
  hasConflicts: PropTypes.bool,
  buildingData: PropTypes.object,
  formState: PropTypes.object,
  style: PropTypes.object,
}

export default SelectDateAndTime
